// extracted by mini-css-extract-plugin
export default {"expert":"W7jLVviJ","withoutJobTitle":"rHigPTuk","authorInfo":"hQX2JnML","avatar":"eagcH_wF"};